var _mask, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 18,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 0.89543 3.89543 0 5 0H15V4C15 5.10457 15.8954 6 17 6H21V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V2Z",
    fill: "#47A7FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3 2C3 0.89543 3.89543 0 5 0H15V4C15 5.10457 15.8954 6 17 6H21V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M19 23.5H5C4.17157 23.5 3.5 22.8284 3.5 22V2C3.5 1.17157 4.17157 0.5 5 0.5H15H19C19.8284 0.5 20.5 1.17157 20.5 2V6V22C20.5 22.8284 19.8284 23.5 19 23.5Z",
    stroke: "#EB5A3E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29395 16.0557C7.57227 16.0557 7.73633 15.8857 7.73633 15.5957V14.667H8.52734C9.41797 14.667 10.0361 14.0869 10.0361 13.2197C10.0361 12.3496 9.43848 11.7725 8.57129 11.7725H7.29395C7.01562 11.7725 6.85156 11.9424 6.85156 12.2324V15.5957C6.85156 15.8857 7.01562 16.0557 7.29395 16.0557ZM7.73633 13.9756V12.4727H8.33691C8.84375 12.4727 9.13672 12.7422 9.13672 13.2227C9.13672 13.7061 8.84082 13.9756 8.33398 13.9756H7.73633ZM10.8489 16H12.0208C13.2894 16 14.0364 15.2119 14.0364 13.8701C14.0364 12.5283 13.2894 11.7725 12.0208 11.7725H10.8489C10.5706 11.7725 10.4065 11.9424 10.4065 12.2324V15.5371C10.4065 15.8301 10.5706 16 10.8489 16ZM11.2913 15.2676V12.502H11.9153C12.6946 12.502 13.1341 12.9883 13.1341 13.873C13.1341 14.7871 12.7064 15.2676 11.9153 15.2676H11.2913ZM14.8961 16.0557C15.1744 16.0557 15.3385 15.8857 15.3385 15.5957V14.3359H16.7301C16.9615 14.3359 17.108 14.2041 17.108 13.9844C17.108 13.7676 16.9586 13.6357 16.7301 13.6357H15.3385V12.5049H16.8736C17.1139 12.5049 17.275 12.3672 17.275 12.1387C17.275 11.9102 17.1168 11.7725 16.8736 11.7725H14.8961C14.6178 11.7725 14.4537 11.9424 14.4537 12.2324V15.5957C14.4537 15.8857 14.6178 16.0557 14.8961 16.0557Z",
    fill: "#EB5A3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4V0L21 6H17C15.8954 6 15 5.10457 15 4Z",
    fill: "#EB5A3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.6c7234c9f50e95670ea4a051c6db4f15.svg";
export { ForwardRef as ReactComponent };